import { Dialog, Transition } from '@headlessui/react'
import { Fragment } from 'react'

import ButtonText from '@/components/ui/Typo/ButtonText'
import Subtitle from '@/components/ui/Typo/Subtitle'

interface Props {
  onClose: () => void
  text: string
}

const InfoPopup: React.FC<Props> = ({ onClose, text }) => {
  return (
    <Transition appear show={true} as={Fragment}>
      <Dialog as="div" className="relative z-50" onClose={onClose}>
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-black bg-opacity-25" />
        </Transition.Child>

        <div className="fixed inset-0 overflow-y-auto">
          <div className="flex min-h-full items-center justify-center p-4 text-center">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 scale-95"
              enterTo="opacity-100 scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 scale-100"
              leaveTo="opacity-0 scale-95"
            >
              <Dialog.Panel className="w-full max-w-sm transform overflow-hidden rounded-2xl bg-white desktop:px-8 py-6 small:px-20 px-4 text-left align-middle shadow-xl transition-all">
                <Subtitle
                  weight="font-semibold"
                  className="text-center"
                  color="text-primary"
                >
                  {text}
                </Subtitle>
                <div className="flex justify-center mt-5">
                  <button
                    onClick={onClose}
                    className="rounded-lg px-8 py-3 bg-primary hover:opacity-90 active:scale-x-95 outline-none"
                  >
                    <ButtonText size="small">Oк</ButtonText>
                  </button>
                </div>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition>
  )
}

export default InfoPopup
